// src/pages/History/AncientHistory/HistoryPagePersia.js
import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Classical_Antiquity_-_Persian_Empire.png';



export default function HistoryPagePersia() {
  return (
    <TopicPage
      topicKey="Persian Empire"
      title="History: Persian Empire"
      backgroundImage={bg}
      startRoute="/History-Persian-Empire-Go"
      scrollLabels={[
        "Cyrus and Darius",
        "Government and Infrastructure",
        "Conflict with Greece",
      ]}
  backRoute="/history-Classical-Antiquity"   // go back to the Middle-Ages menu
  backLabel="← Return to topics"
  backButtonClassName="journey-button special"
  backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}